import {
  ALL_TECHNOLOGIES_TITLE,
  COLORS,
  device,
  FONTS,
} from '../../../../constants';
import { Title } from '../../../../components';
import styled, { css, keyframes } from 'styled-components';
import { techIcons } from './data';
import { TechnologyElement } from '../../../../components/Technology/TechnologyElement';

const AllTechnologies = () => {
  return (
    <TechnologyWrapper>
      <Title
        title={ALL_TECHNOLOGIES_TITLE}
        fontFamily={FONTS.TITLE}
        size={36}
        lineHeight={46}
        color={COLORS.SECTION_TITLE}
        isAnimated={true} 
      />
      <AllTechnologiesWrapper>
        {techIcons.map((row, rowIndex) => (
          <TechnologyAnimate
            direction={rowIndex % 2 === 0 ? 'left' : 'right'}
            key={rowIndex}
          >
            <TechnologyRow>
              {row.map((item, index) => (
                <TechnologyElement
                  key={index}
                  src={item.icon}
                  title={item.text}
                />
              ))}
            </TechnologyRow>
            <TechnologyRow>
              {row.map((item, index) => (
                <TechnologyElement
                  key={index}
                  src={item.icon}
                  title={item.text}
                />
              ))}
            </TechnologyRow>
          </TechnologyAnimate>
        ))}
      </AllTechnologiesWrapper>
      <TechnologyCover1 />
      <TechnologyCover2 />
    </TechnologyWrapper>
  );
};

const slideLeft = keyframes`
    0% { transform: translateX(0); }
    100% { transform: translateX(-50%); }
`;
const slideRight = keyframes`
    0% { transform: translateX(-50%); }
    100% { transform: translateX(0); }
`;
const AllTechnologiesWrapper = styled.div`
  width: 85%;
  margin: 0 auto;
  overflow: hidden;
  position: relative;
  gap: 40px;
  display: flex;
  flex-direction: column;
  -moz-user-select: none;
  -ms-user-select: none;
  -webkit-user-select: none;
  user-select: none;
  @media screen and ${device.md} {
    gap: 15px;
    max-width: 90%;
  }
  @media screen and ${device.sm} {
    gap: 8px;
    max-width: 95%;
  }
`;
const TechnologyAnimate = styled.div<{ direction: 'left' | 'right' }>`
  display: inline-flex;
  flex-direction: row;
  width: max-content;
  flex-shrink: 0;
  justify-content: center;
  overflow: visible;
  min-width: 200%;
  ${({ direction }) =>
    direction === 'left'
      ? css`
          animation: ${slideRight} 30s infinite linear;
        `
      : css`
          animation: ${slideLeft} 30s infinite linear;
        `}
`;
const TechnologyRow = styled.div`
  display: inline-flex;
  width: max-content;
  min-width: 50%;
  gap: 10px;
  position: relative;
  justify-content: space-between;
  flex-shrink: 0;
  &::after {
    content: '';
    min-width: 0;
  }
`;

const TechnologyWrapper = styled.div`
  > span {
    text-align: center;
    width: 100%;
    display: block;
  }
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 60px;
  @media screen and ${device.md} {
    gap: 20px;
    > span {
      font-size: 24px;
      line-height: 28px;
    }
  }
  @media screen and ${device.sm} {
    > span {
      font-size: 20px;
      line-height: 24px;
      max-width: 70%;
      margin: 0 auto;
    }
  }
`;
const TechnologyCover1 = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  width: 13%;
  background: linear-gradient(
    270deg,
    rgba(245, 245, 247, 0) 0%,
    #f5f5f7 34.67%
  );
`;
const TechnologyCover2 = styled.div`
  position: absolute;
  right: 0;
  top: 0;
  bottom: 0;
  width: 13%;
  background: linear-gradient(
    270deg,
    rgba(245, 245, 247, 0) 0%,
    #f5f5f7 34.67%
  );
  transform: rotate(180deg);
`;

export default AllTechnologies;
